var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex gap-1 w-full items-footer items-center" },
    [
      _vm.title ? _c("span", [_vm._v(_vm._s(_vm.title) + ":")]) : _vm._e(),
      _vm.items.length > 0
        ? _c(
            "div",
            {
              staticClass: "flex flex-row gap-1 items-center",
              class: _vm.getContentClasses,
            },
            [
              _vm._l(_vm.getItems, function (sk) {
                return _c(
                  "div",
                  {
                    key: sk.name,
                    staticClass: "items-chip",
                    class: _vm.chipsClasses,
                    attrs: { title: sk.name },
                  },
                  [_vm._v(" " + _vm._s(sk.name) + " ")]
                )
              }),
              _vm.showMoreOption
                ? _c(
                    "div",
                    { staticClass: "more_items", class: _vm.chipsClasses },
                    [
                      _c("div", { staticClass: "items-chip-plus" }, [
                        _vm._v(
                          " +" +
                            _vm._s(_vm.items.length - _vm.showMoreAfter) +
                            " "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.items.length === 0
        ? _c("div", { staticClass: "empty_items" }, [_vm._v("n/a")])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }